import { render } from "./announcement-bar.vue?vue&type=template&id=16fe5734&scoped=true"
import script from "./announcement-bar.vue?vue&type=script&lang=js"
export * from "./announcement-bar.vue?vue&type=script&lang=js"

import "./announcement-bar.vue?vue&type=style&index=0&id=16fe5734&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fe5734"]])

export default __exports__